<template>
  <div>
    <div class="col-md-12" style="padding-left: 5%; padding-right: 5%;">
      <div class="bg-plans-form mt-10">
        <h2>
          จัดการข้อมูลบริษัท
        </h2>
        <br />
        <b-button variant="success" @click="companyActionModal()">+ เพิ่มบริษัท</b-button>
        <div class="table-responsive mt-3">
          <table ref="table_1" id="table_1" class="display" style="width:100%">
          </table>
        </div>

      </div>
    </div>
    <b-modal id="companyCreateForm" ref="companyActionModal" centered no-enforce-focus size="lg" title="เพิ่มบริษัท">
      <label class="mr-sm-2">บริษัท</label>
      <b-form-input v-model="companyCreateForm.companyName" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">ที่อยู่</label>
      <b-form-input v-model="companyCreateForm.address" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">ที่อยู่ 2</label>
      <b-form-input v-model="companyCreateForm.address2" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">ตำบล</label>
      <b-form-select id="companyCreateForm_subDistrict" class="plans-form-select custom-select2"
        v-model="companyCreateForm.subDistrict" :options="formSetting.subDistrict"></b-form-select>

      <label class="mr-sm-2 mt-3">อำเภอ/เขต</label>
      <b-form-select id="companyCreateForm_district" class="plans-form-select custom-select2"
        v-model="companyCreateForm.district" :options="formSetting.district"></b-form-select>

      <label class="mr-sm-2 mt-3">จังหวัด</label>
      <b-form-select id="companyCreateForm_province" class="plans-form-select custom-select2"
        v-model="companyCreateForm.province" :options="formSetting.province"></b-form-select>

      <label class="mr-sm-2 mt-3">รหัสไปรษณีย์</label>
      <b-form-input v-model="companyCreateForm.postCode" size="sm" type="number"></b-form-input>

      <label class="mr-sm-2 mt-3">เลขประจำตัวผู้เสียภาษี</label>
      <b-form-input v-model="companyCreateForm.taxId" size="sm" type="number"></b-form-input>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmActionCompany()">
          ยืนยีน
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FetchService from "@/core/services/fetch.service";
import DataTable from 'datatables.net-bs4';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import $ from "jquery";
import moment from "moment";
import ThaiTambons from '@/assets/master_data/thai_geo_data/thai_tambons.json'
import ThaiAmphures from '@/assets/master_data/thai_geo_data/thai_amphures.json'
import ThaiProvinces from '@/assets/master_data/thai_geo_data/thai_provinces.json'
import Swal from 'sweetalert2'
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL || "http://localhost:3000",
      masterDataTable: {},
      dataTable: [],
      masterData: [],
      companyCreateForm: {
        companyName: "",
        address: "",
        address2: "",
        subDistrict: "",
        district: "",
        province: "",
        postCode: "",
        taxId: "",
      },
      companyEditMode: 0,
      companyIdSelect: "",
      formSetting: {
        companyData: "",
        address: "",
        address2: "",
        subDistrict: "",
        district: "",
        province: "",
        postCode: "",
        taxId: ""
      },
    };
  },
  created() {
    if (ThaiTambons) {
      this.formSetting.subDistrict = ThaiTambons.RECORDS.map(e => {
        return {
          value: e.name_th,
          text: e.name_th
        }
      })
    }

    if (ThaiAmphures) {
      this.formSetting.district = ThaiAmphures.RECORDS.map(e => {
        return {
          value: e.name_th,
          text: e.name_th
        }
      })
    }

    if (ThaiProvinces) {
      this.formSetting.province = ThaiProvinces.RECORDS.map(e => {
        return {
          value: e.name_th,
          text: e.name_th
        }
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.getDataTable()
    }, 100)
  },
  methods: {
    getDataTable() {
      if (this.masterDataTable?.destroy) {
        this.masterDataTable.destroy()
      }
      FetchService.get("/getcompany", (response) => {
        if (response) {
          response = JSON.parse(response)
          console.log("response", response)
          this.masterData = response.allCompany
          this.pageInit()
        }
      })
    },
    pageInit() {

      let that = this

      let arrTable = this.masterData.map((row, index) => {
        let fullAddress = (row?.address || "") + " " + (row?.address2 || "");
        return [
          row?._id ? row._id : "",
          row?.name ? row.name : "",
          fullAddress.trim(),
          row?.subDistrict ? row.subDistrict : "",
          row?.district ? row.district : "",
          row?.province ? row.province : "",
          row?.postCode ? row.postCode : "",
          row?.taxId ? row.taxId : "",
          `<button type="button" class="btn btn-warning mr-4 mb-2 btn-edit" style="cursor: pointer" value="${row?._id}">แก้ไข</button> <button type="button" class="btn btn-danger mr-4 btn-del" style="cursor: pointer" value="${row?._id}">ลบ</button>`,
        ]
      })

      this.masterDataTable = new DataTable('#table_1', {
        data: arrTable,
        columns: [
          { title: 'ID' },
          { title: 'ชื่อบริษัท' },
          { title: 'ที่อยู่' },
          { title: 'ตำบล' },
          { title: 'อำเภอ' },
          { title: 'จังหวัด' },
          { title: 'รหัสไปรษณีย์' },
          { title: 'เลขประจำตัวผู้เสียภาษี' },
          { title: 'ดำเนินการ' }
        ],
        dom: 'Bfrtip'
      });

      $('#table_1').on('click', '.btn-edit', (event) => {
        var data = event.currentTarget.value
        that.actionEditCompany(data)
      });

      $('#table_1').on('click', '.btn-del', (event) => {
        var data = event.currentTarget.value
        that.actionDelCompany(data)
      });

    },
    actionEditCompany(companyId) {
      this.companyActionModal()

      const rowData = this.findMasterDataById(companyId)
      this.companyCreateForm = {
        companyName: rowData.name,
        address: rowData.address,
        address2: rowData.address2,
        subDistrict: rowData.subDistrict,
        district: rowData.district,
        province: rowData.province,
        postCode: rowData.postCode,
        taxId: rowData.taxId,
      }

      this.companyEditMode = 1
      this.companyIdSelect = companyId

    },
    actionDelCompany(companyId) {
      this.companyIdSelect = companyId
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบบริษัท ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delCompany()
        }
      })
    },
    findMasterDataById(id) {
      return this.masterData.find(e => {
        return e._id === id
      })
    },
    companyActionModal() {
      this.clearForm()
      this.$refs["companyActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    addCompany() {
      var raw = JSON.stringify({
        "companyName": this.companyCreateForm.companyName,
        "address": this.companyCreateForm.address,
        "address2": this.companyCreateForm.address2,
        "subDistrict": $('#companyCreateForm_subDistrict').val(),
        "district": $('#companyCreateForm_district').val(),
        "province": $('#companyCreateForm_province').val(),
        "postCode": this.companyCreateForm.postCode,
        "taxId": this.companyCreateForm.taxId
      });

      FetchService.post("/addcompany", raw, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["companyActionModal"].hide()
      })

    },
    editCompany() {
      var raw = JSON.stringify({
        "companyName": this.companyCreateForm.companyName,
        "address": this.companyCreateForm.address,
        "address2": this.companyCreateForm.address2,
        "subDistrict": $('#companyCreateForm_subDistrict').val(),
        "district": $('#companyCreateForm_district').val(),
        "province": $('#companyCreateForm_province').val(),
        "postCode": this.companyCreateForm.postCode,
        "taxId": this.companyCreateForm.taxId
      });

      FetchService.post(`/editcompany/${this.companyIdSelect}`, raw, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'แก้ไขข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["companyActionModal"].hide()
      })
    },
    delCompany() {
      FetchService.get(`/deletecompany/${this.companyIdSelect}`, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'ลบข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["companyActionModal"].hide()
      })
    },
    clearForm() {
      this.companyCreateForm = {
        companyName: "",
        address: "",
        address2: "",
        subDistrict: "",
        district: "",
        province: "",
        postCode: "",
        taxId: "",
      }
      this.companyEditMode = 0
    },
    confirmActionCompany() {
      if (this.companyCreateForm.companyName == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่อบริษัท',
          'error'
        )
      } else {
        if (this.companyEditMode === 1) {
          Swal.fire({
            title: 'ยืนยันการแก้ไข ?',
            text: "คุณยืนยันการแก้ไขบริษัท ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.editCompany()
            }
          })
        } else {
          Swal.fire({
            title: 'ยืนยันการบันทึก ?',
            text: "คุณยืนยันการบันทึกบริษัท ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.addCompany()
            }
          })
        }
      }
    }
  }
}
</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_1 table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_1 th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_1 thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_1 thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_1 thead tr:first-child th {
  border-top-style: solid;
}

#table_1 thead tr th:first-child {
  border-left-style: solid;
}

#table_1 td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_1 tbody th {
  border-style: none solid solid solid;
}

#table_1 tbody tr:first-child td:first-child {
  /* border-top-left-radius: 10px; */
}

#table_1 tbody tr:first-child td:last-child {
  /* border-top-right-radius: 10px; */
}

#table_1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_1 tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_1 tbody tr:first-child td {
  border-top-style: solid;
}

#table_1 tbody tr td:first-child {
  border-left-style: solid;
}

#table_1 tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_1 tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_1 tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}

.dt-search {
  text-align: right;
}
</style>